import React from 'react';
import { IconButton, Typography } from '@mui/material';
import { ComplianceCollapse } from './ComplianceCollapse';
import { LayoutGridItem } from 'app/layout/LayoutGrid';
import { makeStyles } from 'tss-react/mui';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useTranslation } from 'react-i18next';
import { IEngineRequirement } from 'app/models/Placement/CredOneCompliance';

const useComplianceTableStyles = makeStyles()(() => ({
  tableHeaderFont: {
    color: '#333333',
    fontSize: '14px',
    fontWeight: '500',
  },
  arrowIcon: {
    fontSize: '16px',
    marginBottom: '4px',
    color: '#333333',
  },
}));

/**
 * Component to render compliance table
 */
export const ComplianceTable = ({ requirementsLayer }) => {
  const { classes } = useComplianceTableStyles();
  const { t } = useTranslation();
  return (
    <LayoutGridItem container item>
      <LayoutGridItem
        item
        xs={12}
        sx={{
          display: 'flex',
          direction: 'row',
          justifyContent: 'space-between',
          background: '#F5F5F5',
          alignItems: 'center',
          height: '48px',
          borderBottom: '1px solid #c2c2c2',
        }}
        px="45px"
      >
        <Typography className={classes.tableHeaderFont} component="div">
          {t('placement.profile.tabs.credentialingTab.credOneCompliance.requirement')}
          <IconButton color="primary" size="small" sx={{ paddingLeft: '6px' }}>
            <ArrowUpwardIcon className={classes.arrowIcon} />
          </IconButton>
        </Typography>
        <Typography className={classes.tableHeaderFont}>
          {t('placement.profile.tabs.credentialingTab.credOneCompliance.requirementSet')}
        </Typography>
      </LayoutGridItem>
      <LayoutGridItem
        item
        sx={{
          width: '100%',
          height: '80vh',
          overflowY: 'scroll',
        }}
      >
        {requirementsLayer.map((complianceItem: IEngineRequirement, index: number) => (
          <ComplianceCollapse complianceItem={complianceItem} index={index} />
        ))}
      </LayoutGridItem>
    </LayoutGridItem>
  );
};
